import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getGuessList(id,guesserContent,isAwards,pageNum,pageSize) {
  return request({
    url: '/guess/getGuessList',
    params: {
      activityId:id,
      guesserContent:guesserContent,
      isAwards:isAwards,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function isAwardsTrue(id) {
  return requestMsg({
    url: '/guess/isAwardsTrue',
    params: {
      id:id
    }
  })
}

export function isAwardsFalse(id) {
  return requestMsg({
    url: '/guess/isAwardsFalse',
    params: {
      id:id
    }
  })
}

